import styles from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { i18n } from '@lingui/core';
import { ActionIcon, Group, Menu, SegmentedControl, Stack, Text, useMatches } from '@mantine/core';
import { useState } from 'react';
import { NotificationList } from './NotificationList';
import classes from './Notifications.module.css';
export const NotificationButton: React.FC = () => {
  const [value, setValue] = useState('system');
  const [active, setActive] = useState(false);
  // const ref = useClickOutside(() => setActive(false))

  const width = useMatches({
    sm: 318,
    lg: 256
  });
  return <Menu shadow="md" width={width} withArrow arrowSize={15} transitionProps={{
    duration: 200,
    transition: 'fade-down'
  }} classNames={classes} radius={5} onChange={() => setActive(!active)}>
      <Menu.Target>
        <ActionIcon size="input-md" classNames={{
        root: styles.btnIcon
      }} mod={{
        active: active
      }}
      // visibleFrom="xl"
      >
          <Icons className="icon-pr-line-bell" fontSize={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown bg="var(--navbar-bg-color)" pos="fixed" top={85}>
        <Stack gap={16} py={15} px={10}>
          <Group justify="space-between">
            <Text fz="xs" tt="uppercase" fw={700}>
              {i18n._('Notifications')}
            </Text>
          </Group>

          <SegmentedControl size="lg" value={value} onChange={setValue} data={[{
          label: 'System',
          value: 'system'
        }, {
          label: 'Account',
          value: 'account'
        }]} classNames={{
          root: classes.root,
          indicator: classes.indicator,
          label: classes.label
        }} />

          <NotificationList type={value} />
        </Stack>
      </Menu.Dropdown>
    </Menu>;
};